export class datos
{
    nombre:string;
    tabla:string
    constructor (nombre:string,tabla:string)
    {
        this.nombre=nombre;
        this.tabla=tabla;
    }
}

export const RastreoExcel:datos=
{
    nombre:"Rastreo",
    tabla:"rastroBusqueda"
}

export const BusquedaExcel:datos=
{
    nombre:"Historial",
    tabla:"tablaHistorial"
}

